import { SpinningLoader } from 'br2s-ui-componentlibrary_r2_02';

function Loading() {
  return <SpinningLoader isFullScreen />;
}

export default Loading;
